/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_You1Inputs */

const zh_organizationsettings_you1 = /** @type {(inputs: Organizationsettings_You1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const en_organizationsettings_you1 = /** @type {(inputs: Organizationsettings_You1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const es_organizationsettings_you1 = /** @type {(inputs: Organizationsettings_You1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Organizationsettings_You1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_you1 = /** @type {((inputs?: Organizationsettings_You1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_You1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_you1(inputs)
	if (locale === "en") return en_organizationsettings_you1(inputs)
	return es_organizationsettings_you1(inputs)
});
export { organizationsettings_you1 as "organizationSettings_you" }